import { Avatar } from "../../Avatar";
import { InputSearch } from "../../ui_kit/Input_search";
import React, { useEffect, useState } from "react";
import styles from "./navMiddle.module.scss";
import favoriteIcon from "../../../assets/img/favorite_ico.svg";
import UserUtils from "../../../commons/utils/UserUtils";
import UserManager from "../../../commons/utils/Auth/UserManager";
import { Logo } from "../../Logo";
import { getUrlRedirectFavoriteAuth } from "commons/utils/Utils";

interface NavMiddleProps {
    children?: any;
}

export const NavMiddle: React.FC<NavMiddleProps> = ({ children }) => {
    const [Logged, setLogged] = useState(false);

    useEffect(() => {
        if (UserManager.isLogin()) {
            setLogged(true);
        }
    }, []);

    const firstName = Logged ? UserUtils.getFistName() : "";
    const lastName = Logged ? UserUtils.getLastName() : "";
    const email = Logged ? UserUtils.getEmail() : "";

    return (
        <div className={styles.middle_box}>
            <div className={styles.middle_box__logo}>
                <Logo />
            </div>
            <div className={styles.middle_box__search}>
                <InputSearch />
            </div>
            <div className={styles.middle_box__actions}>
                <div
                    className={styles.middle_box__actions__favorites}
                    onClick={() =>
                        (window.location.href = getUrlRedirectFavoriteAuth())
                    }
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31.189"
                        height="31.187"
                        viewBox="0 0 31.189 31.187"
                        className={styles.middle_box__actions__favorites__icon}
                    >
                        <g transform="translate(-291.556 -11.555)">
                            <g transform="translate(291.556 11.555)">
                                <rect
                                    className={styles.a}
                                    width="31.189"
                                    height="31.187"
                                />
                            </g>
                            <g transform="translate(295.602 13.852)">
                                <path
                                    className={styles.b}
                                    d="M38.09,34.4l-11.545-5.56-2.423,1.167L15,34.4V7.693H38.09Z"
                                    transform="translate(-15 -7.693)"
                                />
                                <path
                                    className={styles.c}
                                    d="M266.384,388.711l1.683,5.179h5.446l-4.406,3.2,1.683,5.179-4.405-3.2-4.406,3.2,1.683-5.179-4.405-3.2H264.7Z"
                                    transform="translate(-254.923 -384.956)"
                                />
                            </g>
                        </g>
                    </svg>

                    <span className={styles.text}>Favoritos</span>
                </div>
                <Avatar
                    isLogged={Logged}
                    firstName={firstName}
                    lastName={lastName}
                    email={email}
                />
            </div>
        </div>
    );
};
